import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useEffect } from 'react';
import { useCentralizedProviderData } from '@crehana/auth';
export var LoadIntercom = function LoadIntercom(_ref) {
  var _config$enabled, _config$forceToLoad;
  var config = _ref.config;
  var _useCentralizedProvid = useCentralizedProviderData(),
    me = _useCentralizedProvid.me,
    loading = _useCentralizedProvid.loading,
    error = _useCentralizedProvid.error;
  var intercomEnabled = (_config$enabled = config === null || config === void 0 ? void 0 : config.enabled) !== null && _config$enabled !== void 0 ? _config$enabled : true;
  var intercomForceToLoad = (_config$forceToLoad = config === null || config === void 0 ? void 0 : config.forceToLoad) !== null && _config$forceToLoad !== void 0 ? _config$forceToLoad : false;
  var isProduction = process.env.APP_ENV === 'production';
  useEffect(function () {
    if (me && me.organization && !loading && !error && (intercomEnabled && isProduction || intercomForceToLoad)) {
      var loadAndInitIntercom = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var intercom;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return import('@intercom/messenger-js-sdk').then(function (module) {
                  return module.Intercom;
                });
              case 2:
                intercom = _context.sent;
                intercom({
                  app_id: (config === null || config === void 0 ? void 0 : config.appId) || 'mevliu65',
                  user_id: me.id.toString(),
                  name: me.user.fullName,
                  email: me.user.email,
                  created_at: me.user.createdAt ? new Date(me.user.createdAt).getTime() / 1000 : undefined
                });
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function loadAndInitIntercom() {
          return _ref2.apply(this, arguments);
        };
      }();
      loadAndInitIntercom();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- no required to depend on config because config is static
  }, [me, loading, error]);
  return null;
};